import RecentInspections from './RecentInspections';
import { useFastInspectionCouncil } from '../../hooks/useFastInspectionCouncil';
import InspectionTab, { COUNCIL_MODELS_STRIKE } from './InspectionTab';

// شورای ضربت container. Reuses the parameterized InspectionTab with the
// 2-member roster and stage-2 hidden so the look matches the full council
// (cards, severity styling, verdict layout, all the same) but the flow is
// simpler: parallel round 1 → chairman.
export default function FastInspectionTabContainer({ slots, concealModelIdentities }) {
  const props = useFastInspectionCouncil({ slots, concealModelIdentities });
  return (
    <>
      <InspectionTab
        {...props}
        councilModels={COUNCIL_MODELS_STRIKE}
        showStage2={false}
      />
      <RecentInspections variant="fast" finishedRun={props.finalVerdict || props.error} />
    </>
  );
}
